import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Tooltip,
  IconButton,
  Modal,
  Button,
  TextField,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import CountUp from "react-countup";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {  deleteKeyDetail } from "../Dossier/Network_call";
import { toast  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const KeyData = ({ filteredData, onDataChange, dossierData, refreshDossierData }) => {
  const [firstDate, setFirstDate] = useState("");
  const [recentDate, setRecentDate] = useState("");
  const [numTransactions, setNumTransactions] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [modalData, setModalData] = useState({ label: "", value: "", id: null });

  const initialDataFields = [
    { label: "First Interaction Date", value: "", specificDate: "", id: "firstInteractionDate" },
    { label: "Recent Interaction Date", value: "", specificDate: "", id: "recentInteractionDate" },
    { label: "Became Customer on", value: "--", specificDate: "", editable: true, id: "becameCustomer" },
    { label: "Number of Transactions", value: "0", id: "numTransactions" },
    { label: "First Purchase", value: "--", specificDate: "", editable: true, id: "firstPurchase" },
    { label: "Recent Purchase", value: "--", specificDate: "", editable: true, id: "recentPurchase" },
    { label: "Customer Rating", value: "--", editable: true, id: "customerRating" },
    { label: "Campaign Response", value: "--", editable: true, id: "campaignResponse" },
    { label: "Ranking", value: "--", editable: true, id: "rankingTop20" },
  ];

  const [dataFields, setDataFields] = useState(initialDataFields);

  console.log("ssss",filteredData)

  useEffect(() => {
    if (filteredData.length !== 0) {
      const validDates = filteredData.filter((entry) => new Date(entry.date) <= new Date());
      const sortedDates = validDates.sort((a, b) => new Date(b.date) - new Date(a.date));

      if (sortedDates.length > 0) {
        const first = filteredData[filteredData.length - 1].date;
        const mostRecent = sortedDates[0].date;

        const { relativeTime: firstRelativeTime, specificDate: firstSpecificDate } = dateCalculation(first);
        setFirstDate(firstRelativeTime);

        const { relativeTime: recentRelativeTime, specificDate: recentSpecificDate } = dateCalculation(mostRecent);
        setRecentDate(recentRelativeTime);

        const transactions = filteredData.filter((e) => e.status.toLowerCase() === 'closed won' || e.status.toLowerCase() === 'deal won').length;
        setNumTransactions(transactions);

        const updatedDataFields = initialDataFields.map((field) => {
          if (field.label === "First Interaction Date") {
            return { ...field, value: firstRelativeTime, specificDate: firstSpecificDate };
          } else if (field.label === "Recent Interaction Date") {
            return { ...field, value: recentRelativeTime, specificDate: recentSpecificDate };
          } else if (dossierData[field.label] && dossierData[field.label] !== "--") {
            if (field.label === "Customer Rating" || field.label === "Ranking" || field.label === "Campaign Response") {
              return { ...field, value: dossierData[field.label] };
            } else {
              const { relativeTime, specificDate } = dateCalculation(dossierData[field.label]);
              return { ...field, value: relativeTime, specificDate: specificDate };
            }
          } else if (field.label === "Number of Transactions") {
            return { ...field, value: transactions.toString() };
          }
          return field;
        });

        setDataFields(updatedDataFields);
      }
    }
  }, [filteredData, dossierData]);

  const handleInputChange = (value) => {
    setModalData({ ...modalData, value });
  };

  const handleEditClick = (index) => {
    setIsModalOpen(true);
    setEditingIndex(index);

    const label = dataFields[index].label;
    let value = dataFields[index].value;

    if (dossierData[label] && dossierData[label] !== "--") {
      value = dossierData[label];
      if (label === "Became Customer on" || label === "First Purchase" || label === "Recent Purchase") {
        const date = new Date(value);
        const formattedDate = date.toISOString().split('T')[0];
        value = formattedDate;
      }
    }
    setModalData({ label: label, value: value, id: dataFields[index].id });
  };

  const handleSaveClick = async () => {
    const updatedDataFields = [...dataFields];
  
    if (modalData.label === "Became Customer on" || modalData.label === "First Purchase" || modalData.label === "Recent Purchase") {
      const { relativeTime, specificDate } = dateCalculation(modalData.value);
      updatedDataFields[editingIndex].value = relativeTime;
      updatedDataFields[editingIndex].specificDate = specificDate;
    } else {
      updatedDataFields[editingIndex].value = modalData.value;
    }
    setDataFields(updatedDataFields);
    onDataChange(updatedDataFields); 
    setIsModalOpen(false);
  };
  

  const handleDeleteClick = async () => {
    try {
      const result = await deleteKeyDetail({id :{id: dossierData.id,label: modalData.label}});
  
      if (result.status === 200) {
        console.log("Dossier detail deleted successfully");
  
        setIsModalOpen(false);
  
        const newDataFields = [...dataFields];
        newDataFields[editingIndex].value = "--";
        newDataFields[editingIndex].specificDate = "";
        
        setDataFields(newDataFields);
        onDataChange(newDataFields);
        refreshDossierData();
        
        toast.success("Dossier detail deleted successfully");
      } else {
        console.error("Failed to delete dossier detail");
        toast.error("Failed to delete dossier detail");
      }
    } catch (error) {
      console.error("Error during dossier detail deletion:", error);
      toast.error("An error occurred while deleting dossier detail");
    }
  };
  

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(/ /g, '/');
  }

  function dateCalculation(formattedDate) {
    const targetDate = new Date(formattedDate);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const specificDate = targetDate.toLocaleDateString('en-GB', options).replace(/ /g, '/');

    const currentDate = new Date();
    const timeDifference = currentDate - targetDate;
    let numberOfDays = timeDifference / (1000 * 60 * 60 * 24);

    if (numberOfDays < 0) {
      return { relativeTime: "", specificDate };
    }

    const isYear = Math.floor(numberOfDays / 365);
    const isMonth = Math.floor(numberOfDays / 30);
    const isWeek = Math.floor(numberOfDays / 7);

    let relativeTime;
    if (isYear > 0) {
      relativeTime = (Math.floor(numberOfDays) / 365).toFixed(1) + " years ago";
    } else if (isMonth > 0) {
      relativeTime = isMonth === 1 ? "1 month ago" : isMonth + " months ago";
    } else if (isWeek > 0) {
      relativeTime = isWeek === 1 ? "1 week ago" : isWeek + " weeks ago";
    } else {
      relativeTime = numberOfDays === 1 ? "1 day ago" : Math.floor(numberOfDays) + " days ago";
    }

    return { relativeTime, specificDate };
  }

  const renderModalContent = () => {
    const label = modalData.label;
    if (label === "Became Customer on" || label === "First Purchase" || label === "Recent Purchase") {
      return (
        <TextField
          label="Event Date"
          type="date"
          value={modalData.value !== "--" ? modalData.value : ""}
          onChange={(e) => setModalData({ ...modalData, value: e.target.value })}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      );
    } else if (label === "Customer Rating" || label === "Ranking") {
      return (
        <TextField
          label={label}
          type="number"
          value={modalData.value !== "--" ? modalData.value : ""}
          onChange={(e) => setModalData({ ...modalData, value: e.target.value })}
          fullWidth
        />
      );
    } else if (label === "Campaign Response") {
      return (
        <ReactQuill
          value={modalData.value}
          onChange={handleInputChange}
          style={{ marginBottom: "20px" }}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Box sx={{ padding: "20px", margin: "0 auto", maxWidth: "900px" }}>
        <Box sx={{ marginTop: "20px" }}>
          <Grid container spacing={2}>
            {dataFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    borderRadius: "1rem",
                    boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
                    border: "1.5px solid #00A0B2",
                  }}
                >
                  <CardContent>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Typography variant="body1" component="div" sx={{ color: "#838194", fontWeight: "bold" }}>
                        {field.label}
                      </Typography>
                      <Tooltip title={`Details about ${field.label}`}>
                        <IconButton size="small">
                          <InfoIcon fontSize="small" sx={{ color: "#00A0B2" }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Typography variant="body2" component="div" sx={{ marginTop: "10px", fontWeight: "bold" }}>
                      {field.label === "Number of Transactions" ? (
                        <CountUp
                          delay={1}
                          duration={3}
                          start={0}
                          end={parseInt(field.value)}
                        />
                      ) : field.label === "Campaign Response" ? (
                        <div dangerouslySetInnerHTML={{ __html: field.value }} />
                      ) : (
                        field.value
                      )}
                    </Typography>
                    {field.specificDate && (
                      <Typography variant="body" component="div" sx={{ marginTop: "10px", color: "black", fontSize: "0.8rem" }}>
                        {field.specificDate}
                      </Typography>
                    )}
                    {field.editable && (
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton onClick={() => handleEditClick(index)}>
                          <EditIcon fontSize="small" sx={{ color: "#00A0B2" }} />
                        </IconButton>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Box sx={{ padding: "20px", margin: "100px auto", maxWidth: "500px", backgroundColor: "white", borderRadius: "1rem", boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)" }}>
          <Typography variant="h6" component="div" sx={{ marginBottom: "20px", fontWeight: "bold" }}>
            Edit {modalData.label}
          </Typography>
          {renderModalContent()}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "0.4rem", marginTop: "1rem" }}>
              <Button variant="contained" color="primary" onClick={handleSaveClick}>
                Set
              </Button>
              <Button variant="contained" color="primary" onClick={handleDeleteClick}>
                Delete
              </Button>
            </Box>
            <Button variant="contained" color="error" sx={{ maxHeight: "2.5rem", marginTop: "1rem" }} onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default KeyData;